import { BgImage } from '~/components/atoms/bg-element/BgImage';
import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';

import AnonymousQR from './components/AnonymousQR/AnonymousQR';
import Benefits from './components/benefits/Benefits';
import CreateQrPoster from './components/create-qr-poster/CreateQrPoster';
import DesignYourQrCode from './components/design-your-qr-code/DesignYourQrCode';
import FAQ from './components/FAQ/FAQ';
import Features from './components/features/Features';
import Possibilities from './components/possibilities/Possibilities';
// import QrCodesOn from './components/qr-codes-on/QrCodesOn';
import QrMakerSteps from './components/qr-maker-steps/QrMakerSteps';
// import Reviews from './components/Reviews/Reviews';
import TryQrCodePoster from './components/try-our-qr-code/TryQrCodePoster';
import { StyledContainer, StyledGrayContainer, StyledLayout } from './styled';

export default function HomePage() {
  return (
    <StyledLayout>
      <HeaderPublic />
      <StyledContainer>
        <div className="customContainer">
          <BgImage.circles $top={-200} $right={-180} />
          <BgImage.circles $top={300} $left={-180} $rotate={30} />
          <BgImage.circlesFilled $top={3850} $left={-80} />
          <AnonymousQR />
        </div>
        <QrMakerSteps />
        {/*<BenefitsCounter />*/}
        <div className="customContainer">
          <TryQrCodePoster />
          <Possibilities />
        </div>
        <Benefits />
        <DesignYourQrCode />
        <StyledGrayContainer>
          {/*<QrCodesOn />*/}
          <Features />
        </StyledGrayContainer>
        {/*<Reviews />*/}
        <StyledGrayContainer>
          <div className="customContainer">
            <FAQ />
            <CreateQrPoster />
          </div>
        </StyledGrayContainer>
      </StyledContainer>
      <FooterPublic />
    </StyledLayout>
  );
}
